<template>
  <div>
    <v-list shaped class="unfinished_test_list">
      <v-subheader class="section">
        <h5>Continue what you left (click to resume):</h5>
      </v-subheader>
      <v-list-item-group v-model="item">
        <v-list-item v-for="(test, i) in unfinished_tests" :key="i">
          <v-list-item-content class="p-4">
            <v-list-item-title
              v-text="
              `${test.test_info.standard}
                ${test.test_info.grade} Grade ${test.test_info.subject} 
                 ${test.test_info.range_start} to ${test.test_info.range_end}, 
                 last access: ${test.test_date} with ${test.test_info
                .time_remain / 60} minutes remaining`"
            ></v-list-item-title>
            <v-progress-linear
              height="20"
              color="#546E7A"
              :value="Math.ceil(Object.keys(test.user_answers).length*100/Object.keys(test.questions).length)"
              rounded
            >
              <strong>{{Math.ceil(Object.keys(test.user_answers).length*100/Object.keys(test.questions).length)}}%</strong>
            </v-progress-linear>
          </v-list-item-content>
          <br />
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-divider :inset="inset" color="primary"></v-divider>

    <div class="section">
      <v-subheader>
        <h5>Or, Choose a new test:</h5>
      </v-subheader>
    </div>
    <div class="all_select d-flex flex-row mb-6 ml-10 mr-5" elevation-1>
      <v-select
        :items="new_test_selector.standard"
        :rules="[v => !!v || 'Selection is required']"
        label="Standard"
        required
        class="selection"
      ></v-select>

      <v-select
        :items="new_test_selector.grade"
        :rules="[v => !!v || 'Selection is required']"
        label="Grade"
        required
        class="selection"
      ></v-select>

      <v-select
        :items="new_test_selector.term"
        :rules="[v => !!v || 'Selection is required']"
        label="Term"
        required
        class="selection"
      ></v-select>

      <v-select
        :items="new_test_selector.subject"
        :rules="[v => !!v || 'Selection is required']"
        label="Subject"
        required
        multiple
        class="selection"
      ></v-select>

      <v-select
        :items="new_test_selector.sample_range"
        :rules="[v => !!v || 'Selection is required']"
        label="Test Range"
        required
        class="selection"
      ></v-select>

      <v-select
        :items="new_test_selector.duration"
        :rules="[v => !!v || 'Selection is required']"
        label="Duration"
        required
        class="selection"
      ></v-select>

      <v-select
        :items="new_test_selector.difficulty"
        :rules="[v => !!v || 'Selection is required']"
        label="Difficulty"
        required
        class="selection"
      ></v-select>
    </div>
    <h6 class="ml-10">Note:</h6>
    <p
      class="mx-10"
    >Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur eveniet obcaecati, corrupti commodi voluptatibus veritatis, quis facilis deleniti pariatur ea officia inventore vero beatae dolores est ut non voluptatum ratione!</p>
    <v-checkbox class="mx-10" label="By checking the box on the left, I understand test procedures"></v-checkbox>

    <div class="mx-10 d-flex flex-row">
      <div class="w-75 d-inline">
        Your
        <b>{{new_test_selector.standard[0]}} Standard {{new_test_selector.grade[2]}}'s grade {{new_test_selector.subject[0]}}</b> test has been generaged. You will have
        <b>8</b> questions and
        <b>30 minutes</b> to complete. Click "Start" whenever you are ready.
      </div>
      <v-btn rounded class="d-inline ml-10" color="primary" dark>Start</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    unfinished_tests: [
      {
        test_id: 1,
        test_date: "08-09-2019:13:20",
        test_info: {
          standard: "NYSED",
          grade: "3rd",
          subject: "Math",
          range_start: 2008,
          range_end: 2019,
          duration: "15-30 min",
          time_remain: "1860", //seconds
          difficulty: "medium" //pValue,
        },
        test_score: 80,

        questions: {
          //question_ids
          q1: "q74WA4X7",
          q2: "qE22TK3I",
          q3: "qR1O0QTB",
          q4: "q31X97N2"
        },

        user_answers: {
          a1: "A",
          a2: "75",
          a3: "B to 285"
        }
      },

      {
        test_id: 1,
        test_date: "08-09-2019:13:20",
        test_info: {
          standard: "Common Core",
          grade: "4th",
          subject: "ELA",
          range_start: 2008,
          range_end: 2019,
          duration: "15-30 min",
          time_remain: "180", //seconds
          difficulty: "medium" //pValue,
        },
        test_score: 80,

        questions: {
          //question_ids
          q1: "q74WA4X7",
          q2: "qE22TK3I",
          q3: "qR1O0QTB",
          q4: "q31X97N2",
          q5: "q31X97N2",
          q6: "q31X97N2"
        },

        user_answers: {
          a1: "A",
          a2: "75",
          a3: "B to 285"
        }
      }
    ],
    new_test_selector: {
      standard: ["New York State", "Texas State", "Common Core"],
      grade: ["K", "1st", "2nd"],
      term: ["Spring", "Fall"],
      subject: ["Math", "ELA"],
      sample_range: ["Past 1 year", "Past 2 years", "Past 3 years"],
      duration: [
        "15 to 30 min",
        "30 to 45 min",
        "45 to 1 hour",
        "1 hour to 1.5 hours"
      ],
      difficulty: ["Easy", "Medium", "Challenging"]
    }
  })
};
</script>

<style scoped>
.unfinished_test_list {
  width: 80%;
  /* padding: 30px; */
}
.section {
  padding: 30px;
}
.selection {
  padding: 5x;
  margin: 5px;
}
</style>
